import { combineReducers } from 'redux'
import auth from './auth'
import user from './user'
import modalStates from './modals'
import editorState from './editor'
import ignoreList from './ignoreList'

export default combineReducers({
    auth,
    user,
    modalStates,
    editorState,
    ignoreList,
})
